import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Reports_custom_ds_count_tasks_report_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get($inParams: { warehouse_id?: number, inventory_count_id?: number }): Promise<{ result?: { result?: { TaskId?: number, Project?: string, MaterialLookupCode?: string, MaterialDescription?: string, InventoryCountId?: number, CreatedDateTime?: string, TotalExpected?: number, TotalActual?: number, Differences?: number, Accuracy?: number, TotalCounted?: number, TaskCount?: number }[] } }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      warehouse_id?: number, inventory_count_id?: number    }) {
      return false;
    }
}
